"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.windowsMatch = exports.shouldShowCustomWindowSelected = exports.DateWindowComponent = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var React = require("react");
var DateWindowCustomComponent_1 = require("./DateWindowCustomComponent");
var DateWindowTypeDropdownComponent_1 = require("./DateWindowTypeDropdownComponent");
var DateWindowComponent = function (props) {
    var dateTrunc = (0, metrics_engine_1.dateTruncFromGranularity)(props.dateGranularity);
    var willShowCustomWindowSelected = (0, exports.shouldShowCustomWindowSelected)(props.selectedDateWindow, props.dateGranularity);
    var initialSelectedCustomWindow = canShowWindowAsCustom(props.selectedDateWindow)
        ? props.selectedDateWindow
        : defaultCustomWindow(dateTrunc);
    var _a = React.useState(willShowCustomWindowSelected), isCustomWindowSelected = _a[0], setIsCustomWindowSelected = _a[1];
    var _b = React.useState(initialSelectedCustomWindow), lastCustomDateWindow = _b[0], setLastCustomDateWindow = _b[1];
    React.useEffect(function () {
        if (isCustomWindowSelected) {
            if (!(0, exports.windowsMatch)(props.selectedDateWindow, lastCustomDateWindow)) {
                props.onChange(lastCustomDateWindow);
            }
        }
    }, [isCustomWindowSelected, lastCustomDateWindow]);
    var onCustomDateWindowChanged = function (window) {
        if (isCustomWindowSelected) {
            setLastCustomDateWindow(window);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DateWindowTypeDropdownComponent_1.DateWindowTypeDropdownComponent, { testId: 'date-window-type-dropdown', setCustomWindowSelected: setIsCustomWindowSelected, isCustomWindowSelected: isCustomWindowSelected, dateTrunc: dateTrunc, selectedDateWindow: props.selectedDateWindow, onChange: props.onChange, disabled: props.disabled, dropdownRef: props.dropdownRef }),
        isCustomWindowSelected && (React.createElement(DateWindowCustomComponent_1.DateWindowCustomComponent, { testId: 'date-window-custom', dateTrunc: dateTrunc, data: props.data, onChange: onCustomDateWindowChanged, selectedDateWindow: props.selectedDateWindow, validationCounter: props.validationCounter, disabled: props.disabled }))));
};
exports.DateWindowComponent = DateWindowComponent;
/**
 * Our date window picker shows both "presets", as well as "custom" input controls.
 * The "relative date" preset windows can also be expressed via the "custom" UI.
 *
 * This differs from `shouldShowCustomWindowSelected`, as that function only
 * returns true if the given window does not appear in the preset list. This
 * function ignores the preset list entirely.
 *
 * @param selectedWindow the window to test
 * @returns `true` if the `selectedWindow` can be expressed via the "Custom"
 * window picker UI.
 */
var canShowWindowAsCustom = function (selectedWindow) {
    if (selectedWindow === null) {
        return false;
    }
    if (selectedWindow.type === metrics_engine_1.DateWindowTypes.SPECIAL) {
        return false;
    }
    return true;
};
/**
 *
 * @param selectedWindow the window to test
 * @param granularity the granularity of the metric
 * @returns `true` if the `selectedWindow` should result in "Custom" being
 * initially selected in the date picker dropdown
 */
var shouldShowCustomWindowSelected = function (selectedWindow, granularity) {
    if (selectedWindow === null) {
        return false;
    }
    if (selectedWindow.type === metrics_engine_1.DateWindowTypes.CUSTOM) {
        return true;
    }
    if (selectedWindow.type === metrics_engine_1.DateWindowTypes.DEFINED_START) {
        return true;
    }
    if (selectedWindow.type === metrics_engine_1.DateWindowTypes.SPECIAL) {
        // There is only one "Special" window type: All Time
        return false;
    }
    var defaultOptions = (0, metrics_engine_1.dateWindowOptions)((0, metrics_engine_1.dateTruncFromGranularity)(granularity));
    var indexOfWindowInDefaultList = defaultOptions.findIndex(function (window) { return (0, metrics_engine_1.areWindowsEqual)(window, selectedWindow); });
    if (indexOfWindowInDefaultList === -1) {
        return true;
    }
    return false;
};
exports.shouldShowCustomWindowSelected = shouldShowCustomWindowSelected;
var windowsMatch = function (window, other) {
    if (window === null && other === null) {
        return true;
    }
    if (window === null || other === null) {
        return false;
    }
    return (0, metrics_engine_1.areWindowsEqual)(window, other);
};
exports.windowsMatch = windowsMatch;
function defaultCustomWindow(dateTrunc) {
    return dateTrunc === metrics_engine_1.DateTrunc.UNKNOWN
        ? (0, metrics_engine_1.createLastNWindow)(1)
        : (0, metrics_engine_1.createRelativeWindow)({ unit: dateTrunc, numberOfUnits: 1 });
}
//# sourceMappingURL=DateWindowComponent.js.map